import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "inputStudent"
}, " Seleccione el cargo a pagar ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "inputPaymentDate"
}, "Fecha de pago", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "inputMethod"
}, "Método", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "inputReference"
}, "Referencia", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "inputAmount"
}, "Valor", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "inputStatus"
}, "Estado", -1)
const _hoisted_11 = { class: "d-sm-flex align-items-center" }
const _hoisted_12 = { class: "search-box position-relative" }
const _hoisted_13 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_14 = { class: "table-responsive" }
const _hoisted_15 = { class: "text-center text-success my-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, " Cargando...", -1)
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen p-2" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center" }
const _hoisted_21 = { class: "mb-0 text-paragraph" }
const _hoisted_22 = { class: "fw-bold" }
const _hoisted_23 = { class: "fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_b_container = _resolveComponent("b-container")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_TableAuditColumns = _resolveComponent("TableAuditColumns")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_pagination = _resolveComponent("b-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_b_button, {
          class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
          type: "button",
          onClick: _ctx.openModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Nuevo pago "),
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_b_modal, {
          class: "modal fade",
          modelValue: _ctx.form.dialog,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.dialog) = $event)),
          tabindex: "-1",
          "aria-hidden": "true",
          title: _ctx.form.record.Id > 0 ? `Editar Pago` : `Nuevo Pago`,
          "ok-disabled": "",
          "hide-footer": true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form, {
                  onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_group, null, {
                              default: _withCtx(() => [
                                _hoisted_5,
                                _createVNode(_component_SearchSelect, {
                                  modelValue: _ctx.form.record.ChargeId,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.record.ChargeId) = $event)),
                                  required: "",
                                  "was-validated": _ctx.form.wasValidated,
                                  onChange: _ctx.updateAmount,
                                  options: _ctx.charges.map(r => ({ value: r.Id, text: `Ref: ${r.SequenceId} - Fecha: ${r.CollectionDate?.substring(0, 10)} - Valor: ` + r.Amount.toLocaleString() })),
                                  placeholder: "Seleccione el cargo"
                                }, null, 8, ["modelValue", "was-validated", "onChange", "options"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_group, null, {
                              default: _withCtx(() => [
                                _hoisted_6,
                                _createVNode(_component_b_form_input, {
                                  id: "inputPaymentDate",
                                  modelValue: _ctx.form.record.PaymentDate,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.record.PaymentDate) = $event)),
                                  type: "date",
                                  required: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_group, null, {
                              default: _withCtx(() => [
                                _hoisted_7,
                                _createVNode(_component_b_form_select, {
                                  id: "inputMethod",
                                  modelValue: _ctx.form.record.Method,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.record.Method) = $event)),
                                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                                  options: _ctx.methodOfPayments,
                                  required: ""
                                }, null, 8, ["modelValue", "options"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_b_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_group, null, {
                              default: _withCtx(() => [
                                _hoisted_8,
                                _createVNode(_component_b_form_input, {
                                  id: "inputReference",
                                  modelValue: _ctx.form.record.Reference,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.record.Reference) = $event)),
                                  placeholder: "Referencia de pago"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_group, null, {
                              default: _withCtx(() => [
                                _hoisted_9,
                                _createVNode(_component_b_form_input, {
                                  id: "inputAmount",
                                  modelValue: _ctx.form.record.Amount,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.record.Amount) = $event)),
                                  type: "number",
                                  placeholder: "Ej: 150000",
                                  required: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_form_group, null, {
                              default: _withCtx(() => [
                                _hoisted_10,
                                _createVNode(_component_b_form_select, {
                                  id: "inputStatus",
                                  modelValue: _ctx.form.record.Status,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.record.Status) = $event)),
                                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                                  options: _ctx.paymentOptions,
                                  required: ""
                                }, null, 8, ["modelValue", "options"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_button, {
                              type: "submit",
                              class: "default-btn bg-success text-white"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Guardar ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "title"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("form", _hoisted_12, [
          _createVNode(_component_b_form_input, {
            modelValue: _ctx.table.filters.search,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.table.filters.search) = $event)),
            class: "search-box position-relative form-control shadow-none text-black rounded-0 border-0",
            type: "search",
            placeholder: "Buscar..."
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_b_table, {
          id: "tableList",
          class: "table text-nowrap align-middle mb-0",
          striped: "",
          hover: "",
          "sticky-header": "",
          small: "",
          keyword: _ctx.table.filters.search,
          busy: _ctx.table.loading,
          items: _ctx.filteredItems,
          fields: _ctx.table.headers,
          "per-page": _ctx.table.rowsPerPage,
          "current-page": _ctx.table.currentPage
        }, {
          "table-busy": _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_b_spinner, { class: "align-middle" }),
              _hoisted_16
            ])
          ]),
          "cell(StudentId)": _withCtx(({ item }) => [
            _createTextVNode(_toDisplayString(_ctx.students.find(s => s.Id === item.StudentId)?.Name || `ID ${item.StudentId}`), 1)
          ]),
          "cell(PaymentDate)": _withCtx(({ item }) => [
            _createTextVNode(_toDisplayString(new Date(item.PaymentDate).toLocaleDateString()), 1)
          ]),
          "cell(Amount)": _withCtx(({ item }) => [
            _createTextVNode(_toDisplayString(item.Amount.toLocaleString()), 1)
          ]),
          "cell(CreatedByFormat)": _withCtx(({ item }) => [
            _createVNode(_component_TableAuditColumns, {
              item: item,
              mode: "created"
            }, null, 8, ["item"])
          ]),
          "cell(ModifiedByFormat)": _withCtx(({ item }) => [
            _createVNode(_component_TableAuditColumns, {
              item: item,
              mode: "modified"
            }, null, 8, ["item"])
          ]),
          "cell(action)": _withCtx(({ item }) => [
            _createElementVNode("button", {
              type: "button",
              onClick: ($event: any) => (_ctx.edit(item)),
              class: "bg-transparent p-0 border-0 text-paragraph fs-15"
            }, _hoisted_19, 8, _hoisted_17)
          ]),
          _: 1
        }, 8, ["keyword", "busy", "items", "fields", "per-page", "current-page"]),
        _createVNode(_component_b_pagination, {
          modelValue: _ctx.table.currentPage,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.table.currentPage) = $event)),
          "current-page": _ctx.table.currentPage,
          "per-page": _ctx.table.rowsPerPage,
          "aria-controls": "tableList",
          "total-rows": _ctx.rows,
          class: "mt-3"
        }, null, 8, ["modelValue", "current-page", "per-page", "total-rows"])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("p", _hoisted_21, [
          _createTextVNode(" Mostrando "),
          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.table.rowsPerPage), 1),
          _createTextVNode(" de "),
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.table.records.length), 1),
          _createTextVNode(" resultados ")
        ])
      ])
    ])
  ]))
}